import React, { useEffect } from 'react';
import StaticParticles from '../StaticParticles/StaticParticles';
import './Modal.css';

const THEME = {
  cyan: { particle: '#06B6D4', border: '#06B6D4' },
  gold: { particle: '#FDB241', border: '#FDB241' },
};

const Modal = ({ isOpen, onClose, theme = 'gold', children }) => {
  const colors = THEME[theme] || THEME.gold;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-content theme-${theme}`} onClick={(e) => e.stopPropagation()}>
        
        {/* Частицы фона */}
        <StaticParticles 
          count={300}
          color={colors.particle}
          opacity={0.6}
          sway={0.5}
        />
        
        {/* Рамка */}
        <div className="modal-golden-border"></div>
        
        <div className="modal-close">
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
